"use client";
import {NeoSelect, NeoTextBox} from "@/components/forms";
import {NeoCard, SearchIcon} from "@/components/shared";
import {StatusType} from "@/libs/enums/live";
import {liveService} from "@/service/live.service";
import {SelectItem} from "@nextui-org/react";
import React, {useEffect, useState} from "react";
import toast from "react-hot-toast";
import {Progressbar} from "./progressbar";
import {StudentDetails} from "./students";

interface TripViewProps {
  status?: StatusType;
  client?: any;
  onSendTripdata?: (data: any) => void;
}

export const TripView: React.FC<TripViewProps> = function ({
  status,
  client,
  onSendTripdata
}: TripViewProps) {
  const [openId, setOpenId] = useState<number | null>(null);
  const [filterValues, setFilterValues] = useState<any>([]);
  const [trips, setTrips] = useState<any>([]);
  const [selectedRouteByIndex, setSelectedRouteByIndex] = useState<
    Record<number, string>
  >({});
  const [selectedroute, setSelectedRoute] = useState<string | null>(null);
  const [routeusers, setRouteUsers] = useState<any[]>([]);
  const [stopscovered, setStopsCovered] = useState<number>(0);
  const [routedata, setRouteData] = useState<any>({});
  const [history, setHistory] = useState<any>({});
  const [swipeusers, setSwipeUsers] = useState<any>({});
  const [routedetails, setRouteDetails] = useState<any>({});
  useEffect(() => {
    if (client.institutionUserId) {
      (async () => {
        const response = await liveService.gettripdetails(
          client.institutionUserId,
          client.institutionId
        );
        if (response?.data?.status === "success") {
          const datas = response?.data?.data?.vehicles;
          const routeMap = new Map<string, {}>();
          datas.forEach((bp: any) => {
            if (bp.trips) {
              bp.trips.forEach((trip: any) => {
                const key = String(trip.routeId);
                routeMap.set(key, {
                  tripStart: trip.tripStart,
                  tripEnd: trip.tripEnd,
                  routeName: trip.routeName,
                  tripType: trip.tripType,
                  status: trip.status,
                  tripTypeName:
                    trip.tripType === 0 ? "Pickup Trip" : "Drop Trip"
                });
              });
            }
          });
          setRouteDetails(routeMap);
          setTrips(datas);
          setFilterValues(datas);
          setOpenId(0);
        }
      })();
    }
  }, [client]);

  const toggletrip = (id: any) => {
    setOpenId((curr: any) => (curr === id ? null : id));
  };

  useEffect(() => {
    if (openId == null) {
      resetmapdata();
    } else {
      const opened = filterValues[openId];
      const first = opened?.trips?.[0];
      if (first?.routeId != null) {
        setSelectedRoute(String(first?.routeId));
        setSelectedRouteByIndex(prev => ({
          ...prev,
          [openId]: String(first.routeId)
        }));
      }
    }
  }, [openId, filterValues]);

  useEffect(() => {
    if (selectedroute) {
      (async () => {
        setRouteUsers([]);
        setHistory([]);
        setRouteData({});
        setStopsCovered(0);
        const swipeMap = new Map<
          string,
          {userId: string; startSwipe: number; endSwipe: number}
        >();
        const bpcoverdids: any[] = [];
        const route = routedetails.get(String(selectedroute));
        if (!route.status) {
          if (typeof onSendTripdata === "function") {
            onSendTripdata?.({});
          }
          toast.error(
            "Sorry, you don't have the completed trip for the selected vehicle."
          );
          return false;
        }

        const routeresponse = await liveService.getroutedetails(
          selectedroute,
          client.institutionUserId,
          client.institutionId
        );
        if (routeresponse?.data?.status === "success") {
          const info = routeresponse?.data?.data?.info;
          const historydata = routeresponse?.data?.data?.history;
          for (const bp of info ?? []) {
            const bpId = bp.bpId;
            if (bp.bpCovered) {
              bpcoverdids.push(bpId);
            }
            for (const s of bp.swipes ?? []) {
              const key = `${String(s.userId)}`;
              swipeMap.set(key, {
                userId: String(s.userId),
                startSwipe: Number(s.startSwipe) || 0,
                endSwipe: Number(s.endSwipe) || 0
              });
            }
          }
          setHistory(historydata);
          setStopsCovered(bpcoverdids.length);
          setSwipeUsers(info);
        }

        const allUsers: any[] = [];
        const requestdata = {routeId: selectedroute};
        const response = await liveService.getreferenceroute(requestdata);
        if (response?.data?.status === "success") {
          const datas = response?.data?.data?.userBoardings;
          const refRouteDetails = response?.data?.data?.refRouteDetails;
          datas.forEach((bp: any) => {
            const bpId = bp.bpId;
            if (bpcoverdids.includes(bpId)) {
              bp.bpCovered = true;
            } else {
              bp.bpCovered = false;
            }
            bp.lng = bp.lon;
            if (!Array.isArray(bp.users) || bp.users.length === 0) return;
            for (const user of bp.users) {
              const uid = String(user.userId ?? user.id ?? "");
              const swipe = swipeMap.get(uid);
              const mergedUser = {...user};
              if (swipe) {
                mergedUser.startSwipe = swipe.startSwipe;
                mergedUser.endSwipe = swipe.endSwipe;
                user.startSwipe = swipe.startSwipe;
                user.endSwipe = swipe.endSwipe;
              } else {
                mergedUser.startSwipe = mergedUser.startSwipe ?? 0;
                mergedUser.endSwipe = mergedUser.endSwipe ?? 0;
                user.startSwipe = 0;
                user.endSwipe = 0;
              }
              allUsers.push(mergedUser);
            }
          });
          const routedatas: any = {
            refRouteDetails: refRouteDetails,
            userBoardings: datas
          };
          setRouteData(routedatas);
        }
        setRouteUsers(allUsers);
      })();
    } else {
      setRouteUsers([]);
      setStopsCovered(0);
      resetmapdata();
    }
  }, [selectedroute]);

  const resetmapdata = () => {
    const routedatas: any = {refRouteDetails: [], userBoardings: []};
    setRouteData(routedatas);
    setHistory([]);
    setSelectedRoute(null);
  };

  useEffect(() => {
    if (openId == null) {
      if (typeof onSendTripdata === "function") {
        onSendTripdata?.({});
      }
    } else {
      if (selectedroute) {
        const route = routedetails.get(String(selectedroute));
        if (routedata || history) {
          if (typeof onSendTripdata === "function") {
            routedata.history = history;
            routedata.routedetails = route;
            onSendTripdata?.(routedata);
          }
        }
      } else {
        onSendTripdata?.({});
      }
    }
  }, [openId, routedata, history]);

  const getTripName = (routeid: any) => {
    const route = routedetails.get(String(routeid));
    const tripname = route?.tripTypeName;
    return tripname;
  };

  const handleTripSearch = (query: any) => {
    if (query) {
      const normalize = (query: string) => query.toLowerCase().trim();
      const q = normalize(query);
      const filterdata = trips.filter((v: any) =>
        normalize(v.vehicleName).includes(q)
      );
      setFilterValues(filterdata);
      if (filterdata.length == 0) {
        setFilterValues(filterdata);
        resetmapdata();
        if (typeof onSendTripdata === "function") {
          onSendTripdata?.({});
        }
      }
    } else {
      setFilterValues(trips);
    }
  };

  return (
    <NeoCard radius="none">
      <div className="mb-1 flex items-center justify-center gap-2 p-0.5">
        <NeoTextBox
          isClearable
          className="w-full"
          placeholder="Search"
          //value={filterValues?.searchText}
          onChange={e => handleTripSearch(e?.target?.value)}
          onClear={() => handleTripSearch("")}
          size="sm"
          startContent={<SearchIcon />}
        />
        <div
          className="mr-1 cursor-pointer"
          title="The timings shown here indicate the approximate planned start and end times of the trip"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.75 0C7.82164 0 5.93657 0.571828 4.33319 1.64317C2.72982 2.71451 1.48013 4.23726 0.742179 6.01884C0.00422452 7.80042 -0.188858 9.76082 0.187348 11.6521C0.563554 13.5434 1.49215 15.2807 2.85571 16.6443C4.21928 18.0079 5.95656 18.9365 7.84787 19.3127C9.73919 19.6889 11.6996 19.4958 13.4812 18.7578C15.2627 18.0199 16.7855 16.7702 17.8568 15.1668C18.9282 13.5634 19.5 11.6784 19.5 9.75C19.4973 7.16498 18.4692 4.68661 16.6413 2.85872C14.8134 1.03084 12.335 0.00272983 9.75 0ZM9.375 4.5C9.59751 4.5 9.81501 4.56598 10 4.6896C10.185 4.81321 10.3292 4.98891 10.4144 5.19448C10.4995 5.40005 10.5218 5.62625 10.4784 5.84448C10.435 6.06271 10.3278 6.26316 10.1705 6.4205C10.0132 6.57783 9.81271 6.68498 9.59448 6.72838C9.37625 6.77179 9.15005 6.74951 8.94449 6.66436C8.73892 6.57922 8.56322 6.43502 8.4396 6.25002C8.31598 6.06501 8.25 5.8475 8.25 5.625C8.25 5.32663 8.36853 5.04048 8.57951 4.8295C8.79049 4.61853 9.07664 4.5 9.375 4.5ZM10.5 15C10.1022 15 9.72065 14.842 9.43934 14.5607C9.15804 14.2794 9 13.8978 9 13.5V9.75C8.80109 9.75 8.61033 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61033 8.32902 8.80109 8.25 9 8.25C9.39783 8.25 9.77936 8.40804 10.0607 8.68934C10.342 8.97064 10.5 9.35218 10.5 9.75V13.5C10.6989 13.5 10.8897 13.579 11.0303 13.7197C11.171 13.8603 11.25 14.0511 11.25 14.25C11.25 14.4489 11.171 14.6397 11.0303 14.7803C10.8897 14.921 10.6989 15 10.5 15Z"
              fill="#3366FF"
            />
          </svg>
        </div>
      </div>
      <div className="p-1">
        {filterValues.map((t: any, index: number) => {
          const opentripdiv = openId === index;
          return (
            <div key={index} className="mb-2 rounded-xl border p-2">
              <div className="flex items-center justify-between gap-1">
                <div className="flex shrink-0 items-center rounded-full bg-[#FFC727]/20 p-2">
                  <svg
                    width="20"
                    height="24"
                    viewBox="0 0 20 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.95302 0.28125C15.4983 0.28125 19.906 1.8453 19.906 3.8359V4.54683V18.7654C19.906 19.5519 19.2707 20.1873 18.4842 20.1873V21.6092C18.4842 22.3956 17.8488 23.031 17.0623 23.031H15.6405C14.854 23.031 14.2186 22.3956 14.2186 21.6092V20.1873H5.68744V21.6092C5.68744 22.3956 5.05205 23.031 4.26558 23.031H2.84372C2.05725 23.031 1.42186 22.3956 1.42186 21.6092V20.1873C0.635394 20.1873 0 19.5519 0 18.7654V4.54683V3.8359C0 1.8453 4.40777 0.28125 9.95302 0.28125ZM2.84372 5.96869V11.6561C2.84372 12.4426 3.47912 13.078 4.26558 13.078H15.6405C16.4269 13.078 17.0623 12.4426 17.0623 11.6561V5.96869C17.0623 5.18223 16.4269 4.54683 15.6405 4.54683H4.26558C3.47912 4.54683 2.84372 5.18223 2.84372 5.96869ZM3.55465 18.0545C3.93175 18.0545 4.29341 17.9047 4.56006 17.6381C4.82671 17.3714 4.97651 17.0097 4.97651 16.6326C4.97651 16.2555 4.82671 15.8939 4.56006 15.6272C4.29341 15.3606 3.93175 15.2108 3.55465 15.2108C3.17755 15.2108 2.81589 15.3606 2.54924 15.6272C2.28259 15.8939 2.13279 16.2555 2.13279 16.6326C2.13279 17.0097 2.28259 17.3714 2.54924 17.6381C2.81589 17.9047 3.17755 18.0545 3.55465 18.0545ZM16.3514 18.0545C16.7285 18.0545 17.0902 17.9047 17.3568 17.6381C17.6235 17.3714 17.7733 17.0097 17.7733 16.6326C17.7733 16.2555 17.6235 15.8939 17.3568 15.6272C17.0902 15.3606 16.7285 15.2108 16.3514 15.2108C15.9743 15.2108 15.6126 15.3606 15.346 15.6272C15.0793 15.8939 14.9295 16.2555 14.9295 16.6326C14.9295 17.0097 15.0793 17.3714 15.346 17.6381C15.6126 17.9047 15.9743 18.0545 16.3514 18.0545Z"
                      fill="#FACC15"
                    />
                  </svg>
                </div>
                <div
                  className="flex-1 cursor-pointer"
                  onClick={() => toggletrip(index)}
                >
                  <div
                    className="text-sm font-semibold text-gray-900"
                    title={t.vehicleName}
                  >
                    {t.vehicleName}
                  </div>
                </div>
                {Array.isArray(t?.trips) && t.trips.length > 0 ? (
                  <div className="shrink-0">
                    <div
                      className="cursor-pointer"
                      onClick={() => toggletrip(index)}
                    >
                      {opentripdiv ? (
                        <svg
                          width="17"
                          height="10"
                          viewBox="0 0 17 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.01796 0.870235C8.57362 0.425903 7.85203 0.425903 7.4077 0.870235L0.582767 7.69516C0.138435 8.1395 0.138435 8.86109 0.582767 9.30542C1.0271 9.74975 1.74869 9.74975 2.19302 9.30542L8.2146 3.28384L14.2362 9.30187C14.6805 9.7462 15.4021 9.7462 15.8464 9.30187C16.2908 8.85754 16.2908 8.13594 15.8464 7.69161L9.02151 0.86668L9.01796 0.870235Z"
                            fill="#6B7280"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="17"
                          height="10"
                          viewBox="0 0 17 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.12267 8.83875C8.567 9.28308 9.2886 9.28308 9.73293 8.83875L16.5579 2.01382C17.0022 1.56949 17.0022 0.847893 16.5579 0.403561C16.1135 -0.0407704 15.3919 -0.0407704 14.9476 0.403561L8.92602 6.42514L2.90444 0.407115C2.46011 -0.037216 1.73852 -0.037216 1.29419 0.407115C0.849855 0.851447 0.849855 1.57304 1.29419 2.01737L8.11912 8.8423L8.12267 8.83875Z"
                            fill="#6B7280"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
              {Array.isArray(t?.trips) && t.trips.length > 0 ? (
                <>
                  <div className="mt-2">
                    <div className="mb-2 flex items-center justify-between">
                      <h6 className="m-0 text-[12px] font-semibold text-[#1F2937]">
                        {t.completedTrips}/{t.totalTrips} Completed
                      </h6>
                    </div>
                  </div>
                  <div className="mt-2">
                    <Progressbar trips={t.trips} />
                  </div>
                  <div
                    id={`trip-content-${index}`}
                    className={`mt-3 grid transition-all duration-300 ease-in-out ${opentripdiv ? "grid-rows-[1fr] opacity-100" : "hidden grid-rows-[0fr] opacity-0"}`}
                  >
                    <div className="overflow-hidden">
                      <NeoSelect
                        label=""
                        id={`route-${index}`}
                        placeholder="Please select route"
                        size="md"
                        selectedKeys={
                          selectedroute ? new Set([selectedroute]) : new Set()
                        }
                        onSelectionChange={keys => {
                          const val = String(Array.from(keys)[0] ?? "");
                          setSelectedRouteByIndex(prev => ({
                            ...prev,
                            [t.id]: val
                          }));
                          setSelectedRoute(val);
                        }}
                        defaultSelectedKeys={
                          selectedroute ? new Set([selectedroute]) : new Set()
                        }
                      >
                        {t.trips.map((trip: any) => (
                          <SelectItem key={trip.routeId} value={trip.routeId}>
                            {trip.routeName}
                          </SelectItem>
                        ))}
                      </NeoSelect>
                      <div className="mb-2 mt-2 flex items-center justify-between gap-1 text-xs">
                        {/* Students Count */}
                        <div className="flex items-center gap-1 font-medium">
                          <svg
                            width="15"
                            height="17"
                            viewBox="0 0 15 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.859041 5.52748L5.72299 7.96242C6.14955 8.1757 6.62942 8.28826 7.1093 8.28826C7.58918 8.28826 8.06906 8.1757 8.49562 7.96242L13.3596 5.52748C13.8928 5.26088 14.2186 4.73361 14.2186 4.14117C14.2186 3.54873 13.8928 3.02145 13.3596 2.75485L8.49562 0.319919C7.63658 -0.10664 6.58203 -0.10664 5.72299 0.319919L0.859041 2.75485C0.325843 3.02145 0 3.54873 0 4.14117C0 4.73361 0.325843 5.26088 0.859041 5.52748Z"
                              fill="#FFC727"
                            />
                            <path
                              d="M12.3761 12.5474C12.2517 12.4645 12.0917 12.4941 11.991 12.6067C10.8002 13.9574 9.05251 14.8046 7.1093 14.8046C5.16609 14.8046 3.41839 13.9574 2.22758 12.6067C2.13279 12.4941 1.96691 12.4645 1.84249 12.5474C0.728704 13.288 0 14.5558 0 15.9954C0 16.3213 0.266599 16.582 0.586517 16.582C2.8378 16.582 11.3749 16.582 13.6262 16.582C13.952 16.582 14.2127 16.3213 14.2127 15.9954C14.2186 14.5558 13.4899 13.288 12.3761 12.5474Z"
                              fill="#FFC727"
                            />
                            <path
                              d="M8.75106 9.15861C8.73329 9.15861 8.71551 9.16454 8.69774 9.17046C8.19417 9.37189 7.65504 9.47261 7.11 9.47261C6.44646 9.47261 5.78293 9.31857 5.19641 9.02235L2.2342 7.54125C2.04462 7.44646 1.82541 7.5768 1.80172 7.78415C1.78987 7.92041 1.78394 8.0626 1.77802 8.19886C1.73655 10.776 3.60866 13.0865 6.14432 13.5368C7.88017 13.8389 9.50346 13.2939 10.6646 12.2512C11.7607 11.2618 12.442 9.81623 12.442 8.27588V8.19886C12.436 8.0626 12.4301 7.92041 12.4183 7.78415C12.3946 7.5768 12.1754 7.44646 11.9858 7.54125L10.2381 8.41806C10.1374 8.47138 10.0722 8.5721 10.0722 8.68466V10.0651C10.0722 10.3909 9.80561 10.6575 9.47976 10.6575C9.15392 10.6575 8.88732 10.3909 8.88732 10.0651V9.29488C8.88732 9.21786 8.82808 9.15861 8.75106 9.15861Z"
                              fill="#FFC727"
                            />
                          </svg>
                          <span>{routeusers.length}</span>
                          <span>|</span>
                          <span className="text-xs">User Counts</span>
                        </div>

                        {/* Stops Covered */}
                        <div className="ml-1 flex items-center gap-1 font-medium">
                          <svg
                            width="18"
                            height="21"
                            viewBox="0 0 18 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.16618 19.1525C6.83222 18.1784 6.22101 17.3231 5.40762 16.6917L3.40813 15.1394C1.35499 13.5455 0.108206 11.1281 0 8.53116C0 3.81953 3.81953 0 8.53116 0C13.2428 0 17.0623 3.81953 17.0623 8.53116C16.9541 11.1281 15.7073 13.5455 13.6542 15.1394L11.6547 16.6917C10.8413 17.3231 10.2301 18.1784 9.89615 19.1525L9.66104 19.8384C9.49553 20.3212 9.0415 20.6454 8.53116 20.6454C8.02083 20.6454 7.5668 20.3212 7.40128 19.8384L7.16618 19.1525ZM11.6857 2.77967C10.7765 2.4053 9.71356 2.2181 8.49684 2.2181C7.28012 2.2181 6.2172 2.4053 5.30798 2.77967C4.58597 3.07381 4.18485 3.46157 4.10462 3.94291L3.58309 7.43265V12.2461H4.64632C4.64632 12.9146 4.75992 13.3759 4.98723 13.6299C5.21455 13.884 5.44855 13.884 5.68922 13.6299C5.92989 13.3759 6.05029 12.9146 6.05029 12.2461H10.8631C10.8631 12.9146 10.9835 13.3759 11.2241 13.6299C11.4648 13.884 11.6988 13.884 11.9261 13.6299C12.1534 13.3759 12.267 12.9146 12.267 12.2461H13.4506V7.43265L12.8891 3.94291C12.8088 3.46157 12.4077 3.07381 11.6857 2.77967ZM5.66073 10.6416C5.52159 10.7753 5.35724 10.8422 5.16752 10.8422C4.9778 10.8422 4.81345 10.7753 4.67431 10.6416C4.53517 10.5079 4.46553 10.3408 4.46553 10.1402C4.46553 9.93965 4.53517 9.77253 4.67431 9.63884C4.81345 9.50515 4.9778 9.43827 5.16752 9.43827C5.35724 9.43827 5.52159 9.50515 5.66073 9.63884C5.79987 9.77253 5.86951 9.93965 5.86951 10.1402C5.86951 10.3408 5.79987 10.5079 5.66073 10.6416ZM12.3938 10.6416C12.2508 10.7753 12.0818 10.8422 11.8868 10.8422C11.6918 10.8422 11.5294 10.7753 11.3994 10.6416C11.2695 10.5079 11.2043 10.3408 11.2043 10.1402C11.2043 9.93965 11.2695 9.77253 11.3994 9.63884C11.5294 9.50515 11.6918 9.43827 11.8868 9.43827C12.0818 9.43827 12.2508 9.50515 12.3938 9.63884C12.5369 9.77253 12.6083 9.93965 12.6083 10.1402C12.6083 10.3408 12.5369 10.5079 12.3938 10.6416ZM6.89225 2.90001H10.1816C10.5471 2.90001 10.8434 3.19631 10.8434 3.56184C10.8434 3.92737 10.5471 4.22372 10.1816 4.22372H6.89225C6.52672 4.22372 6.23041 3.92737 6.23041 3.56184C6.23041 3.19631 6.52672 2.90001 6.89225 2.90001ZM5.12003 4.78528H11.9391C12.0277 4.78528 12.1121 4.85709 12.1276 4.9457L12.5913 7.59311C12.6068 7.68172 12.5372 7.75357 12.4357 7.75357H4.62349C4.52197 7.75357 4.45218 7.68172 4.4677 7.59311L4.93141 4.9457C4.94693 4.85709 5.03142 4.78528 5.12003 4.78528Z"
                              fill="#FFC727"
                            />
                          </svg>
                          <span>{stopscovered}</span>
                          <span>|</span>
                          <span className="text-xs">Stops Covered</span>
                        </div>
                      </div>
                      {selectedroute && (
                        <>
                          <div className="mb-1 flex items-center gap-1 font-medium">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.4196 4.70368C16.4196 6.11748 14.7552 8.22692 14.037 9.069C13.93 9.19292 13.7723 9.2408 13.6287 9.20982H11.0123C10.5138 9.20982 10.111 9.61256 10.111 10.111C10.111 10.6095 10.5138 11.0123 11.0123 11.0123H13.716C15.2086 11.0123 16.4196 12.2233 16.4196 13.716C16.4196 15.2086 15.2086 16.4196 13.716 16.4196H5.93161C6.17663 16.1408 6.47516 15.7832 6.77651 15.3832C6.95394 15.1467 7.137 14.8876 7.31161 14.6172H13.716C14.2145 14.6172 14.6172 14.2145 14.6172 13.716C14.6172 13.2175 14.2145 12.8147 13.716 12.8147H11.0123C9.51962 12.8147 8.30859 11.6037 8.30859 10.111C8.30859 8.61839 9.51962 7.40737 11.0123 7.40737H12.1332C11.5417 6.52022 11.0123 5.50071 11.0123 4.70368C11.0123 3.21102 12.2233 2 13.716 2C15.2086 2 16.4196 3.21102 16.4196 4.70368ZM5.29793 15.7747C5.19091 15.8958 5.09515 16.0028 5.01348 16.0929L4.96279 16.1493L4.95715 16.1436C4.78817 16.2732 4.54597 16.2563 4.39389 16.0929C3.68417 15.3213 2 13.3358 2 11.9135C2 10.4208 3.21102 9.20982 4.70368 9.20982C6.19634 9.20982 7.40737 10.4208 7.40737 11.9135C7.40737 12.7584 6.81312 13.8004 6.18226 14.6707C5.88091 15.0847 5.57111 15.4593 5.31483 15.755L5.29793 15.7747ZM5.60491 11.9135C5.60491 11.6745 5.50996 11.4453 5.34095 11.2762C5.17193 11.1072 4.9427 11.0123 4.70368 11.0123C4.46466 11.0123 4.23543 11.1072 4.06642 11.2762C3.89741 11.4453 3.80246 11.6745 3.80246 11.9135C3.80246 12.1525 3.89741 12.3818 4.06642 12.5508C4.23543 12.7198 4.46466 12.8147 4.70368 12.8147C4.9427 12.8147 5.17193 12.7198 5.34095 12.5508C5.50996 12.3818 5.60491 12.1525 5.60491 11.9135ZM13.716 5.60491C13.955 5.60491 14.1842 5.50996 14.3532 5.34095C14.5222 5.17193 14.6172 4.9427 14.6172 4.70368C14.6172 4.46466 14.5222 4.23543 14.3532 4.06642C14.1842 3.89741 13.955 3.80246 13.716 3.80246C13.4769 3.80246 13.2477 3.89741 13.0787 4.06642C12.9097 4.23543 12.8147 4.46466 12.8147 4.70368C12.8147 4.9427 12.9097 5.17193 13.0787 5.34095C13.2477 5.50996 13.4769 5.60491 13.716 5.60491Z"
                                fill="#FFC727"
                              />
                            </svg>
                            <span className="text-xs">
                              {getTripName(selectedroute)}
                            </span>
                          </div>
                          {/*<div className="flex whitespace-nowrap text-center rounded-md bg-green-100 p-[5px] text-[10px] font-bold text-green-700">
                            {getTripName(selectedroute)}
                          </div>*/}
                        </>
                      )}
                      {opentripdiv && routeusers.length > 0 && (
                        <StudentDetails students={routeusers} />
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className="text-center text-sm text-gray-700">
                  No trips available
                </div>
              )}
            </div>
          );
        })}
      </div>
    </NeoCard>
  );
};
